
import { Component, Vue } from "vue-property-decorator";
// import { HappyScroll } from "vue-happy-scroll";
// import { objAny } from "@/common/common-interface";
@Component({
  components: {
    // "happy-scroll": HappyScroll
  }
})
export default class PiFlexScroll extends Vue {}
